import Req from '../../$axios';

const serviceModule = {
  // 获取文件列表
  getFileList(params) {
    return Req({
      url: 'fileTrees/index',
      method: 'get',
      isJSON: true,
      tip: false,
      isAlertErr: true,
    }, params)
  },

  //新建文件夹
  addFolders(params) {
    return Req({
      url: 'folders/save',
      method: 'post',
      isJSON: false,
      tip: false,
      isAlertErr: true,
    }, params)
  },

  //重命名文件或文件夹
  renameFile(params) {
    return Req({
      url: 'fileTrees/rename',
      method: 'post',
      isJSON: false,
      tip: false,
      isAlertErr: false,
    }, params)
  },

  //移动文件或文件夹（支持批量）
  moveFile(params) {
    return Req({
      url: 'fileTrees/move',
      method: 'post',
      isJSON: false,
      tip: false,
      isAlertErr: true,
    }, params)
  },

  //删除文件或文件夹（支持批量）
  deleteFile(params) {
    return Req({
      url: 'fileTrees/delete',
      method: 'delete',
      isJSON: true,
      tip: false,
      isAlertErr: true,
    }, params)
  },

  // 下载附件（支持批量，文件夹压缩下载）
  downFile(params, fn) {
    return Req(
      {
        url: 'fileTrees/batchDownload',
        method: 'get',
        isJSON: true,
        tip: false,
        isAlertErr: true,
        timeout: true,
        onDownloadProgress: fn
      },
      params
    )
  },

  // 获取项目文件列表
  getProjectFiles(params) {
    return Req({
      url: 'fileTrees/projectFileIndex',
      method: 'get',
      isJSON: false,
      tip: false,
      isAlertErr: true,
    }, params)
  },

   // 统计文件数量
   getFilesNum(params) {
    return Req({
      url: 'fileTrees/countTheNumberOfFiles',
      method: 'get',
      isJSON: false,
      tip: false,
      isAlertErr: true,
    }, params)
  }

};

export default {
  ...serviceModule
};
